import { Card } from "../../Common/Card";
import Centered from "../../Common/Centered";
import Layout from "../../Common/Layout";
import Spacer from "../../Common/Spacer";

const InputDemoCard = () => {
	return (
		<Card variant="primary" title="Card test">
			<Spacer pt=".5em" pb=".5em">
				<Spacer pb=".5em">Text Input Test</Spacer>
				<Centered horizontal>
					<Layout horizontal responsive gap="10px">
						<input type="text" placeholder="Search" />
						<input type="text" placeholder="Search" />
					</Layout>
				</Centered>
			</Spacer>
		</Card>
	);
};

export default InputDemoCard;
